function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.528 0C5.203 0 .058 5.14.058 11.46c0 6.32 5.145 11.46 11.47 11.46 6.326 0 11.47-5.14 11.47-11.46C22.998 5.14 17.854 0 11.528 0zm0 21.72c-5.664 0-10.268-4.6-10.268-10.26S5.864 1.2 11.528 1.2c5.665 0 10.269 4.6 10.269 10.26.01 5.66-4.604 10.26-10.269 10.26z",
  fill: "#F66132"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.562 7.44a.61.61 0 00-.851 0l-3.183 3.18-3.183-3.18a.61.61 0 00-.85 0 .6.6 0 000 .85l3.183 3.18-3.183 3.18a.61.61 0 000 .85c.12.12.27.18.42.18.15 0 .31-.06.42-.18l3.183-3.18 3.183 3.18c.12.12.27.18.42.18.15 0 .31-.06.42-.18a.61.61 0 000-.85l-3.182-3.18 3.183-3.18c.25-.24.25-.62.02-.85z",
  fill: "#F66132"
});

function SvgRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "77ce4f1aadf50c885d8f307fa1f38d58.svg";
export { SvgRejected as ReactComponent };